export default __webpack_public_path__ + "static/media/Oportunidades-de-Emprego-EN.c7b70f59.jpg";